import { apiService } from './api.service';
import { ENDPOINTS } from '../config/api';
import { Transcript } from '../types';

class TranscriptService {
  async uploadTranscript(file: File): Promise<Transcript> {
    return apiService.uploadFile<Transcript>(ENDPOINTS.UPLOAD_TRANSCRIPT, file);
  }

  async getTranscripts(): Promise<Transcript[]> {
    return apiService.get<Transcript[]>(ENDPOINTS.TRANSCRIPTS);
  }

  async getTranscript(id: number): Promise<Transcript> {
    return apiService.get<Transcript>(ENDPOINTS.TRANSCRIPT_DETAIL(id));
  }

  async deleteTranscript(id: number): Promise<void> {
    return apiService.delete(ENDPOINTS.TRANSCRIPT_DETAIL(id));
  }
}

export const transcriptService = new TranscriptService();
